import { render, staticRenderFns } from "./PackageItemsEdit.vue?vue&type=template&id=b300803c"
import script from "./PackageItemsEdit.vue?vue&type=script&lang=js"
export * from "./PackageItemsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports